import * as api from '../../../../api';
import { maybeFormatNumberToNational } from '../../../../utils/phoneNumber';

import Contact from './Contact';

interface EmergencyContactProps {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
  relative: boolean;
}

const EmergencyContact = ({ field, relative }: EmergencyContactProps) => {
  const emergencyContact: api.Previsit.EmergencyContact = JSON.parse(
    field.value,
  );

  let relationship: string | null;
  if (relative) {
    relationship =
      emergencyContact.patientRelationshipToEmergencyContact &&
      api.Previsit.relationshipMap[
        emergencyContact.patientRelationshipToEmergencyContact
      ];
  } else {
    relationship =
      emergencyContact.emergencyContactRelationship &&
      api.Previsit.relationshipMap[
        emergencyContact.emergencyContactRelationship
      ];
  }

  const contactPhone =
    (emergencyContact.emergencyContactPhone &&
      maybeFormatNumberToNational(emergencyContact.emergencyContactPhone)) ||
    '';

  return (
    <Contact
      firstName={emergencyContact.emergencyContactFirstName}
      lastName={emergencyContact.emergencyContactLastName}
      contactPhoneNumber={contactPhone}
      relationship={relationship}
      relative={relative}
    />
  );
};

export default EmergencyContact;
